/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MeCheckinRequest = {
  /**
   * Document ID for signing session (optional)
   */
  document_id?: string | null;
  /**
   * Session type
   */
  session_type?: MeCheckinRequest.session_type;
};
export namespace MeCheckinRequest {
  /**
   * Session type
   */
  export enum session_type {
    SIGN = 'sign',
    VERIFY = 'verify',
    ARCHIVE = 'archive',
  }
}
